export const UserRegister = {
	// Step 1
	'Enrollment Form': 'Enrollment Form',
	'Already registered? Sign in!': 'Already registered? Sign in!',
	'Register now': 'Register now',
	// Step 1
	'The registration form is temporarily disabled.':
		'The registration form is temporarily disabled.',
	// Step 2
	'Verify your identity': 'Verify your identity',
	Step2: {
		title: 'Verify your identity',
		description: 'We could not load the identity validation steps.',
		noOrientations:
			'There are no validation steps available at this time. Please contact support.',
	},
	'Back to home': 'Back to home',
	'Go to login': 'Go to login',
	// Identity verification (Truora)
	'Exit the verification process?': 'Exit the verification process?',
	'If you go back you will have to start the validation again.':
		'If you go back you will have to start the validation again.',
	'Yes, go back': 'Yes, go back',
	'Continue verification': 'Continue verification',
	'Error getting the verification link:':
		'Error getting the verification link:',
	'Unknown error': 'Unknown error',
	'Loading verification link...': 'Loading verification link...',
	Back: 'Back',
	// Step 2 (Biomatch)
	'Identity validation service temporarily unavailable, contact support or try again later.':
		'Identity validation service temporarily unavailable, please contact support or try again later.',
};
